export * from './google-tag-manager-config.service';
export * from './google-tag-manager.module';
export * from './google-tag-manager.providers';
export * from './google-tag-manager.service';
export * from './google-tag-manager-config.interface';
